module.exports = __webpack_public_path__ + "static/media/Device-hub-overview.207e51a7.png";